export const removeInternalProps = <T>(contentItems: Record<string, any>) => {
  const slimmedDown = {};
  Object.keys(contentItems).forEach(key => {
    if (key.indexOf('__') !== 0) {
      slimmedDown[key] = contentItems[key];
    }
  });
  return slimmedDown as T;
};
